<script lang="ts">
  /**
 *
 *
 *
 *
 */
</script>

<style lang="scss" global>
  :host {
    width: 100%;
  }
</style>
